import { useQuery } from "@tanstack/react-query";

import type { Blok } from "@/bloks/Article";
import type { DetailsBlok } from "@/bloks/Details/Details";
import getStory from "@/lib/storyblok/getStory";

import UI from "./UI";

interface ProductDesignerProps {
  designer?: Designer;
}

type Designer = {
  name: string | null;
  slug: string | null;
};

const getDesignerStory = async (designer: Designer) => {
  const story = await getStory<Blok>({
    slug: designer.slug || "",
    folder: "designer",
    preview: false,
  });

  return story || null;
};

const ProductDesigner = ({
  designer = {
    name: "",
    slug: "",
  },
}: ProductDesignerProps) => {
  const { data } = useQuery([designer], () => getDesignerStory(designer));
  const details = data?.content?.body?.find(
    (blok) => blok.component === "details"
  ) as DetailsBlok;
  if (!details) {
    return <></>;
  }

  return <UI details={details} />;
};

export default ProductDesigner;
